import { FormattedMessage } from "react-intl";

const style = {
	solWrapper: `py-4 lg:basis-1/2`,
	pyramidMain: `relative flex flex-col items-center justify-center`,
	itemText: `text-lg tracking-wide text-center text-lime lg:text-4xl uppercase aubrey-pro font-bold`,
	triangle: `w-full max-w-[500px] select-none pointer-events-none`,
};

const Pyramid = () => {
	return (
		<div className={style.solWrapper}>
			<p className={style.itemText}>
				<FormattedMessage id='pyramidTitle' />
			</p>
			<div className={style.pyramidMain}>
				<img
					src='./images/triangle.png'
					className={style.triangle}
					alt="Maslow's pyramid"
				/>
			</div>
		</div>
	);
};

export default Pyramid;
